
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as contacttgmq8cuiCK_Z1CtCZ_45GKKDmzitEXQyYkcOGgBFh_aTsMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue?macro=true";
import { default as summarykfdwj6cn_45uRb2EPYaj1p0p0pdztZLWSnW4PGYuA42qkMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue?macro=true";
import { default as prescreentyPkjfNglu_45fnfuUQD4bq5g00hQv3L3i1ig9cbY4pn4Meta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue?macro=true";
import { default as applicationdrjsFG7Tc9bW2YbXsPAhfijjYwbPw2kqZ2bQ3kmc3Y8Meta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue?macro=true";
import { default as attachmentsi9VquN9RIdescXQQgWNKOLNHyM30Vw2SDgcmxaozlqYMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue?macro=true";
import { default as scholarshipsYkKvDgFyAheLb_do339l4c2lWassKY3OjQnWOuQH_45oMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue?macro=true";
import { default as casekfReRbKwpmSPRC1N8hkYn7jyJX4L_458s9ipkPUxhJGd0Meta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case.vue?macro=true";
import { default as index67arnqkVCI_DIVV0Q_45xdm7HsheTdkbkoYXuirAR3o8UMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/index.vue?macro=true";
import { default as searchPeFAyVGxgwWzNEEAbXRVvcFrpRc4u7Zh0bIkZW8JRxwMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/search.vue?macro=true";
import { default as new_45case8pmjrwaJjpOdjkEdY31TzH3LDd30npWIvFcg7XZUyYYMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/new-case.vue?macro=true";
import { default as indextetpcoVKOkF7Ay3yxQbhN69Qy0zQo0j5i66FriqKNxkMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue?macro=true";
import { default as notifications_s7gm_45Uwryl16MxlRoIIdTE0XmxPYX4pX8lUX1_liOAMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue?macro=true";
import { default as settingsfDL_4sZcr0fyMc_45_458WzwlnbIi6lxaL0nkGDe0P9xeqYMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings.vue?macro=true";
import { default as usersnLytFtEjyNilm3EeWjgMm0FPF86Ut8nOUkCk3LjCvQ8Meta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue?macro=true";
import { default as _91id_93IgKwiP8Rp2uuyjoqbTLXRBzihcVoDk6yT2pbyr4hPLkMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue?macro=true";
import { default as providerlistbbqUgBfK0skjs_45DpwpYVx9Q7dS3djJBiDGIbLVYWyZAMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue?macro=true";
import { default as reportsdTO7Nk99f02tFATp9zeXi08ydoQStZqM5s40ifPXyKAMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue?macro=true";
import { default as manage_45flagsS3ULowPj0z_tNZrV8xCKH_s4wHV8dZ57aHF9aKc0JaEMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue?macro=true";
import { default as thank_45you_EY6eEQrthAKwVxadM_QOFvJE_45pgM2Q3dE7cogjbHbAMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue?macro=true";
import { default as thank_45youR0z6ooRHf9ihewZZqKpN7svJblUeZ0xup5dP5iN8qhEMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue?macro=true";
import { default as eligibilitypxNccztsMls7jN6VbYYGRQWmn5rMErn26w3_45lNZdEvAMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue?macro=true";
import { default as case_45assignmentsb1phFiT0ZLZTDdpug5COX7rE95N20unMObS_45kx7eWCQMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue?macro=true";
import { default as income_45eligibilityM7BKMKzT3KYTp8EZwsNg2957P1rac3loMRqsGFphqrMMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue?macro=true";
import { default as scholarship_45age_45dashboardle3MxF5mm5lBlaNDizNyITuWDWsawlbo8PZ5_3dqp_45cMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue?macro=true";
import { default as scholarship_45end_45date_45dashboardzROngq105THyBNPFDCxXemfPZZSFnh_45vnGkUXKZghgMMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue?macro=true";
import { default as scholarship_45enrollment_45dashboardPMyAH13WGUS_45O3_45rvkcFMG_45S_45CsFf_9ehZbOfX6dwCIMeta } from "/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue?macro=true";
export default [
  {
    name: "case",
    path: "/case",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case.vue"),
    children: [
  {
    name: "case-id-contact",
    path: ":id()/contact",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue")
  },
  {
    name: "case-id-summary",
    path: ":id()/summary",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue")
  },
  {
    name: "case-id-prescreen",
    path: ":id()/prescreen",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue")
  },
  {
    name: "case-id-application",
    path: ":id()/application",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue")
  },
  {
    name: "case-id-attachments",
    path: ":id()/attachments",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue")
  },
  {
    name: "case-id-scholarship",
    path: ":id()/scholarship",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/search.vue")
  },
  {
    name: "new-case",
    path: "/new-case",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/new-case.vue")
  },
  {
    name: settingsfDL_4sZcr0fyMc_45_458WzwlnbIi6lxaL0nkGDe0P9xeqYMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue")
  }
]
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(usersnLytFtEjyNilm3EeWjgMm0FPF86Ut8nOUkCk3LjCvQ8Meta || {}), ...{"middleware":"admin-access"} },
    alias: ["/csp-admin/users"],
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue")
  },
  {
    name: "report-id",
    path: "/report/:id()",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue")
  },
  {
    name: "providerlist",
    path: "/providerlist",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue")
  },
  {
    name: "csp-admin-reports",
    path: "/csp-admin/reports",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue")
  },
  {
    name: "admin-manage-flags",
    path: "/admin/manage-flags",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue")
  },
  {
    name: "eligible-thank-you",
    path: "/eligible/thank-you",
    meta: thank_45you_EY6eEQrthAKwVxadM_QOFvJE_45pgM2Q3dE7cogjbHbAMeta || {},
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue")
  },
  {
    name: "ineligible-thank-you",
    path: "/ineligible/thank-you",
    meta: thank_45youR0z6ooRHf9ihewZZqKpN7svJblUeZ0xup5dP5iN8qhEMeta || {},
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue")
  },
  {
    name: "public-csp-eligibility",
    path: "/apply/childcare/eligibility",
    meta: eligibilitypxNccztsMls7jN6VbYYGRQWmn5rMErn26w3_45lNZdEvAMeta || {},
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue")
  },
  {
    name: "csp-admin-case-assignments",
    path: "/csp-admin/case-assignments",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue")
  },
  {
    name: "csp-admin-income-eligibility",
    path: "/csp-admin/income-eligibility",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue")
  },
  {
    name: "csp-admin-scholarship-age-dashboard",
    path: "/csp-admin/scholarship-age-dashboard",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-end-date-dashboard",
    path: "/csp-admin/scholarship-end-date-dashboard",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-enrollment-dashboard",
    path: "/csp-admin/scholarship-enrollment-dashboard",
    component: () => import("/codebuild/output/src2402433998/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue")
  }
]